export const normalizeTag = v =>
  v &&
  v
    .trim()
    .toUpperCase()
    .replace(/^[0-9]/, '') // no number as first place in string
    .replace(/[^\w\s]/gi, '') // no special characters
    .replace(/\^[A-Z][A-Z0-9]*$/, '') // no not uppercase or numbers
    .substring(0, 20); // max 20 char
